import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { apiSlice } from '../features/api/apiSlice'
import { authReducer } from '../features/auth/slices'
import { conversationsReducer } from '../features/conversations/conversationSlice'
import { theaterReducer } from '../features/theaterMode/theaterModeSlice'
import { DataStoreReducer } from './Reducers/DynamicDataStore'

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
}

const authPersistConfig = {
  key: 'auth',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['isAuthenticated'],
}

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  conversations: conversationsReducer,
  theater: theaterReducer,
  dynamicStore: DataStoreReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
})

export default rootReducer
